import React from 'react';
import { Link } from 'react-router-dom';
import logo from '../assets/idxLogo.png';

function Navbar() {
  return (
    <nav className="navbar">
      <div className="navbar-logo">
        <Link to="/">
        <img src={logo} alt="IDX Exchange Logo" style={{ height: '40px' }} />
        </Link>
      </div>
      <div className="navbar-links">
        <Link to="/signin">Sign in/Register</Link>
        <Link to="/">Home</Link>
        <Link to="/about">About</Link>
        <Link to="/contact">Contact us</Link>
      </div>
    </nav>
  );
}

export default Navbar;
